import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center bg-white overflow-hidden pt-32 pb-20" data-id="element-86">
      {/* Minimalist grid background */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:4rem_4rem]" data-id="element-87" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-88">
        <div className="max-w-5xl mx-auto text-center" data-id="element-89">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-90">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-normal text-neutral-900 tracking-tight mb-8 leading-[1.1]" data-id="element-91">
              Вирішення сімейних спорів <br className="hidden md:block" data-id="element-92" />
              <span className="font-semibold" data-id="element-93">без вашої участі.</span>
            </h1>

            <p className="text-xl md:text-2xl text-neutral-600 mb-12 max-w-3xl mx-auto leading-relaxed font-normal" data-id="element-94">
              Швидко. Законно. Конфіденційно. Беру на себе всю бюрократію та
              спілкування в суді, щоб ви могли жити спокійно.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-95">
              <a href="#contact" className="w-full sm:w-auto px-10 py-5 bg-neutral-900 text-white rounded-full font-medium text-lg hover:bg-neutral-800 transition-all duration-300" data-id="element-96">
                Отримати консультацію
              </a>
              <a href="#services" className="w-full sm:w-auto px-10 py-5 bg-white text-neutral-900 border border-neutral-200 rounded-full font-medium text-lg hover:bg-neutral-50 transition-all duration-300" data-id="element-97">
                Дізнатись послуги
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}